import { render, staticRenderFns } from "./AnnouncementsModal.vue?vue&type=template&id=11a6c59d&scoped=true&"
import script from "./AnnouncementsModal.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a6c59d",
  null
  
)

export default component.exports